import { useRef } from 'react';
import Paper from 'components/system/Paper';
import Circuit from 'components/pages/Circuit';
import FullScreenResizer from 'components/system/FullScreenResizer';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import JobDetailExportButton from './JobDetailExportButton';

const JobCircuit = ({ data, isLarge }) => {
  const canvasRef = useRef(null);

  const handleCircuitExport = () => {
    canvasRef.current?.downloadFile();
  };

  const isCircuitAvailable = data && data.layers || isLarge;

  return isCircuitAvailable && (
    <Paper data-test-id="circuit">
      <JobDetailExportButton onClick={handleCircuitExport} buttonText="Circuit diagram" />
      <Paper>
        { isLarge ? (
          <Box sx={{ textAlign: 'center', padding: '15px 0' }}>
            <Typography variant="body2" color="textSecondary">
              This circuit cannot be visualized due to its size.
            </Typography>
          </Box>
        ) : (
          <FullScreenResizer title="Job Circuit">
            <Circuit data-test-id="circuitCanvas" data={data} ref={canvasRef} />
          </FullScreenResizer>
        )}
      </Paper>
    </Paper>
  );
};

export default JobCircuit;
